import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { AccessibilityButton } from "@/components/AccessibilityButton";
import { Construction } from "lucide-react";

export function PageUnavailable() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <div className="flex-1 flex flex-col items-center justify-center py-24 px-6 text-center">
        <div className="w-16 h-16 rounded-2xl bg-brand-primary/8 flex items-center justify-center mb-5">
          <Construction className="w-7 h-7 text-brand-primary/60" />
        </div>
        <h1 className="text-xl font-bold text-gray-800 mb-2">Página temporariamente indisponível</h1>
        <p className="text-gray-400 text-sm max-w-xs">
          Esta página está temporariamente fora do ar. Por favor, volte em breve.
        </p>
        <a
          href="/"
          className="mt-6 inline-flex items-center gap-2 bg-brand-primary text-white text-sm font-semibold px-5 py-2.5 rounded-xl hover:bg-brand-primary/90 transition-colors"
        >
          Voltar à página inicial
        </a>
      </div>
      <Footer />
      <FloatingWhatsApp />
      <AccessibilityButton />
    </div>
  );
}
